import Serializable from "@/core/misc/mixins/Serializable";

class ContractType extends Serializable {

    public id: string;
    public name: string;

    static fromServer(data: any, result = new ContractType()): ContractType {
        super.fromServer(data, result);

        return result;
    }
}

export default ContractType;